module.exports = __webpack_public_path__ + "assets/455f2fe9e8b58b9bcdbb9a51af48a2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/5.png
// module id = 386
// module chunks = 1